import home from './cn/home.js'
import common from './cn/common.js'
import navbar from './cn/navbar.js'
import deploy from './cn/deploy.js'
import industry from './cn/industry.js'

var localeValues = {
  home,
  navbar,
  deploy,
  industry,
  ...common,
}

export default localeValues
